import React, {useEffect, useState} from "react";
import { Card, Button, Row, Col, Form } from "react-bootstrap";
import ForestTable from "./ForestTable";
import RiskOfBiasTable from "./RiskOfBiasTable";

const PreviewForestPanel = ({
  parsedData,
  setParsedData,
  outcomeType,
  intervention,
  comparison,
  robType,
  riskOfBiasMap,
  setRiskOfBiasMap,
  requestForestPlot,
}) => {
  useEffect(() => {
   setMetric(outcomeType === "binary" ? "RR" : "MD");
  }, [outcomeType]);

  const isBinary = outcomeType === "binary";

  const [metric, setMetric] = useState(isBinary ? "RR" : "MD");
  const [model, setModel] = useState("Random");
  const [level, setLevel] = useState("95%");

  const handleGenerate = () => {
    requestForestPlot(parsedData, outcomeType, metric, model, level);
  };

  if (!parsedData.length || !outcomeType) return null;

  const metricOptions = isBinary
    ? ["RR", "OR", "RD"]
    : ["MD", "SMD", "ROM"];

  return (
      <Card className="p-4 shadow-sm rounded-4">
        <h5>Numerical Data</h5>
        <ForestTable
            parsedData={parsedData}
            setParsedData={setParsedData}
            outcomeType={outcomeType}
            intervention={intervention}
            comparator={comparison}
        />

        <div className="mt-4">
          <h5>Risk of Bias</h5>
          <RiskOfBiasTable
              riskOfBiasMap={riskOfBiasMap}
              setRiskOfBiasMap={setRiskOfBiasMap}
              parsedData={parsedData}
              robType={robType}
          />
        </div>

        <Row className="mt-4 position-relative">
          <Col>
            <div className="position-relative" style={{height: "4.5rem"}}>
              {/* Centered Button */}
              <div className="position-absolute top-50 start-50 translate-middle">
                <Button className="logo-color" onClick={handleGenerate}>
                  Generate Forest Plot
                </Button>
              </div>

              {/* Right-aligned dropdowns */}
              <div className="position-absolute top-0 end-0 d-flex gap-3 align-items-start">
                <Form.Group controlId="metricSelect" className="text-end">
                  <Form.Label className="mb-1">Metric</Form.Label>
                  <Form.Select
                      size="sm"
                      value={metric}
                      onChange={(e) => setMetric(e.target.value)}
                  >
                    {metricOptions.map((opt) => (
                        <option key={opt} value={opt}>
                          {opt}
                        </option>
                    ))}
                  </Form.Select>
                </Form.Group>

                <Form.Group controlId="modelSelect" className="text-end">
                  <Form.Label className="mb-1">Effect</Form.Label>
                  <Form.Select
                      size="sm"
                      value={model}
                      onChange={(e) => setModel(e.target.value)}
                  >
                    <option value="Random">Random</option>
                    <option value="Fixed">Fixed</option>
                  </Form.Select>
                </Form.Group>

                <Form.Group controlId="levelSelect" className="text-end">
                  <Form.Label className="mb-1">Level</Form.Label>
                  <Form.Select
                      size="sm"
                      value={level}
                      onChange={(e) => setLevel(e.target.value)}
                  >
                    <option value="95%">95%</option>
                    <option value="99%">99%</option>
                  </Form.Select>
                </Form.Group>
              </div>
            </div>
          </Col>
        </Row>
      </Card>
  );
};

export default PreviewForestPanel;
